import a from "./generateUtilityClasses.mjs";
import t from "./generateUtilityClass.mjs";
const n = (e) => t("MuiDayCalendar", e), o = a("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
export {
  o as dayPickerClasses,
  n as getDayCalendarUtilityClass
};
//# sourceMappingURL=dayCalendarClasses.mjs.map
